import { useHttpClientContext } from '@/shared/context/HttpClientContext';
import { GetPositionConfigurationResponseSchema } from '@/shared/types/positionV2/api/get-position-configuration';
import {
    PostPositionConfigurationRequest,
    PostPositionConfigurationResponseSchema,
} from '@/shared/types/positionV2/api/post-position-configuration';
import {
    PatchPositionConfigurationRequest,
    PatchPositionConfigurationResponseSchema,
} from '@/shared/types/positionV2/api/patch-position-configuration.ts';

export const useCreatePositionClientV2 = () => {
    const { positionClientV2 } = useHttpClientContext();
    return {
        createPositionV2: (body: PostPositionConfigurationRequest) =>
            positionClientV2
                .post(`/v2/positions`, body)
                .then(res => PostPositionConfigurationResponseSchema.parse(res.data)),
    };
};

export const useGetPositionV2ById = () => {
    const { positionClientV2 } = useHttpClientContext();
    return {
        getPositionV2ById: (positionId: string) =>
            positionClientV2
                .get(`/v2/positions/${positionId}`)
                .then(res => GetPositionConfigurationResponseSchema.parse(res.data)),
    };
};

export const usePatchPositionClientV2 = () => {
    const { positionClientV2 } = useHttpClientContext();
    return {
        patchPositionV2: (positionId: string, body: PatchPositionConfigurationRequest) =>
            positionClientV2
                .patch(`/v2/positions/${positionId}`, body)
                .then(res => PatchPositionConfigurationResponseSchema.parse(res.data)),
    };
};
